// removed by extract-text-webpack-plugin
module.exports = {"noTopMargin":"_2DXTbp40dXu06Ze5vP23do","mr20":"_3mekdo5YUNvNRsiPh8Dv-M","itemsStart":"_2QF1nA1AXfAwpVr-0Pec-e","pr150":"KghTDsocewJdXrx17ySeR","resetBtn":"_1bhgM2_q00FyTbJRRFEVXe"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/FreshStart/style.scss
// module id = 2585
// module chunks = 1